export const selectContactPathCountries = state => state.currentUser.formatCountries;
export const selectContactPathSelectedCountries = state => state.currentUser.formatSelectedCountries;
export const selectTimezones = state => state.currentUser.timezones;
export const selectPreferredLanguageList = state =>  state.currentUser.preferredLanguageList
export const selectFirstName = state => state.currentUser.firstName;
export const selectLastName = state => state.currentUser.lastName;
export const selectPreferredLanguage = (state, isEditable=false) => {
    const {preferredLanguage = '' , preferredLanguageList = [] } = state.currentUser
    if(!preferredLanguageList){
        return '';
    }else if(isEditable) {
        return preferredLanguage;
    }
    return preferredLanguageList.find(o=>o.id==preferredLanguage)?.displayLabel ?? "";         
}
export const selectIsPreferredLanguageExposed = state => state.currentUser?.profiles?.preferredLanguage?.expose || false;
export const selectIsPreferredLanguageEditable = state => state.currentUser.isPreferredLanguageEditable;
export const selectIsPreferredLanguageMandatory = state => state.currentUser.isPreferredLanguageMandatory;
export const selectEmail = state => state.currentUser.email;
export const selectRegistrationEmail = state => state.currentUser.registrationEmail;
export const selectShowRegistrationLink = state => state.currentUser.showRegistrationLink;
export const selectIsChangePassword = state => state.currentUser.isChangePassword;
export const selectIsUseDeviceTimeFrame = state => state.currentUser.isUseDeviceTimeFrame;
export const selectTimeZone = state => state.currentUser.timeZone;
export const selectMiddleInitial = state => state.currentUser.middleInitial;
export const selectSuffix = state => state.currentUser.suffix;
export const selectExternalId = state => state.currentUser.externalId;
export const selectProfiles = state => state.currentUser.profiles;
export const selectIsEmailEditable = state => state.currentUser.isEmailEditable;
export const selectContactPaths = state => state.currentUser.contactPaths;
export const selectPageServices = state => state.currentUser.pageServices;
export const selectMinContactPathNum = state => state.currentUser.minContactPathNum;
export const selectOrderMemberPath = state => state.currentUser.orderMemberPath;
export const selectSendNotificationPermission = state => state.currentUser.sendNotificationPermission;
export const selectRecaptchaVerifedToken = state => state.currentUser.recaptchaVerifiedToken;
export const selectHasSentTestNotification = state => state.currentUser.hasSentTestNotification;
export const selectSendErrorMsg = state => state.currentUser.sendErrorMsg;
export const selectHasUniversalProfile = state => state.currentUser.hasUniversalProfile;
